import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MainRoutingModule } from "./main-routing.module";
import { MainComponent } from "./main.component";
import { FullComponent } from "../layouts/full/full.component";
import { AppSidebarComponent } from "../layouts/full/sidebar/sidebar.component";
import { AppHeaderComponent } from "../layouts/full/header/header.component";
import { SharedModule } from "../shared/shared.module";
import { AgmCoreModule } from "@agm/core";
// import { MapComponent } from './map/map.component';
@NgModule({
  declarations: [
    MainComponent,
    FullComponent,
    AppSidebarComponent,
    AppHeaderComponent,
  ],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCRTBC1P4z1GpJTa7QXNPZ63sBPFhNsLms",
    }),
    // DemoMaterialModule
  ],
})
export class MainModule {}
